<div
  [ngClass]="componentClass"
  [ngStyle]="componentStyle"
  [attr.aria-label]="countString">

  <span *ngIf="count !== 0" class="se-avatar__count">
    {{ countString }}
  </span>
</div>